import React from 'react';
import {
  Environment,
  WebflowEnvironments,
} from '@packages/systems/core-constants';

export const useWidgetConfig = (
  className: string,
  runtimeEnvironment: null | Environment,
  previewMode: boolean,
  options?: Record<string, boolean>
) => {
  const nativeNodeRef: {current: null | HTMLDivElement} = React.useRef(null);
  const didMount: {current: boolean} = React.useRef(false);

  React.useEffect(() => {
    if (runtimeEnvironment !== WebflowEnvironments.DESIGNER) return;

    if (didMount.current && previewMode) return;
    didMount.current = true;

    const nativeNode = nativeNodeRef.current;
    if (!nativeNode) return;

    const win = nativeNode.ownerDocument.defaultView;
    if (!win) return;

    const $$: any = 'jQuery' in win ? win.jQuery : null;
    if (!$$) return;
    $$(nativeNode).triggerHandler(`setting.${className}`, [options]);
  });

  return nativeNodeRef;
};
